import React, { useEffect } from "react";
import { MapContainer, TileLayer, Marker, useMap, useMapEvents } from "react-leaflet";
import L from "leaflet";

const spotPin = L.divIcon({ className: "", html: '<div class="wn-pin wn-pin-spot"><span></span></div>', iconSize: [36, 44], iconAnchor: [18, 42] });
const pin = L.divIcon({
  className: "",
  html: '<div class="wn-pin"><span></span></div>',
  iconSize: [36, 44],
  iconAnchor: [18, 42],
});

const DEFAULT: [number, number] = [33.3152, 44.3661];

const ClickPicker = ({ onPick }: { onPick: (lat: number, lng: number) => void }) => {
  useMapEvents({ click: (e) => onPick(+e.latlng.lat.toFixed(6), +e.latlng.lng.toFixed(6)) });
  return null;
};

const Recenter = ({ lat, lng }: { lat: number; lng: number }) => {
  const map = useMap();
  useEffect(() => {
    map.flyTo([lat, lng], Math.max(map.getZoom(), 16), { duration: 0.8 });
  }, [lat, lng, map]);
  return null;
};

export const VenueMap = ({
  lat, lng, onPick, className = "h-64", spot = false,
}: { lat?: number | null; lng?: number | null; onPick?: (lat: number, lng: number) => void; className?: string; spot?: boolean }) => {
  const has = typeof lat === "number" && typeof lng === "number";
  const center: [number, number] = has ? [lat as number, lng as number] : DEFAULT;
  return (
    <div dir="ltr" className={`relative z-0 overflow-hidden rounded-3xl border ${className}`} data-testid={onPick ? "venue-map-picker" : "venue-map"}>
      <MapContainer center={center} zoom={has ? 14 : 6} scrollWheelZoom={!!onPick} className="h-full w-full">
        <TileLayer attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a>' url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png" />
        {has && <Marker position={center} icon={spot ? spotPin : pin} />}
        {has && onPick && <Recenter lat={lat as number} lng={lng as number} />}
        {onPick && <ClickPicker onPick={onPick} />}
      </MapContainer>
    </div>
  );
};
